import { useEffect, useRef } from 'react';
import { useInstanceId } from './useInstanceId';
import { bridge, isApp } from '../utils';

/**
 * 네이티브에 "이 화면을 다 그렸다"고 알린다 — Sentry 트랜잭션의 TTFD 마킹.
 *
 * ⚠️ **TTFD 마커이자 트랜잭션 전송 트리거다.** RN 호스트(`AblyReactActivity` /
 * `AblyReactFragment`)는 `RN_${screen}` 트랜잭션을 열고 TTID 까지 마킹한 뒤
 * **`PERFORMANCE_TTFD` 이벤트에서만 `finish()`** 한다. 그래서 이 훅을 부르지 않는 화면은
 * 트랜잭션이 미완료로 남아 **Sentry 에 전송되지 않는다**(성능 데이터가 통째로 사라진다).
 *
 * @param enabled 데이터가 도착해 실제로 그려진 시점에 보내야 하는 화면은 이 플래그로 늦춘다.
 *   기본 true = 마운트 직후 전송(사실상 TTID 에 가깝다). 한 번 보내면 다시 보내지 않는다.
 */
export const useReportTTFD = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const instanceId = useInstanceId();
  const reportedRef = useRef(false);

  useEffect(() => {
    if (reportedRef.current) return;
    if (!enabled) return;
    if (!instanceId) return;
    if (!isApp()) return;

    reportedRef.current = true;
    bridge.reportTTFD({ instanceId });
  }, [enabled, instanceId]);
};
